import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';


export const INITIAL_STATE = Immutable({
    
    messageFrom: null,
    messageTo: null,
    messageRef: null,

    messages: [],
    chats: [],

    messageLimit: 50,
    messageOffset: 0,

    chatLimit: 50,
    chatOffset: 0,

    errorChat: null,
    errorMessages: null,

    messageUnreadCount: 0

});


const flushMessages = (state) => state.merge({
    messageFrom: null,
    messageTo: null,
    messageRef: null,

    messages: [],
    
    messageLimit: 50,
    messageOffset: 0
})

// const storeMessages = (state, action) => state.merge({
//     messageFrom: action.inFromUser,
//     messageTo: action.inToUser,
//     messageRef: action.inRefUser,

//     messages: action.messages,
    
//     messageLimit: action.inLimit,
//     messageOffset: action.inOffset
// })


const storeMessageFrom = (state, action) => {

    return state.merge({
        messageFrom: action.inFromUser,

        chats: action.response,
        
        chatLimit: action.inLimit,
        chatOffset: action.inOffset,
        errorChat: action.error,
    })
}

const storeMessages = (state, action) => {

    return state.merge({
        messageFrom: action.inFromUser,
        messageTo: action.inToUser,
        messageRef: action.inRefUser,

        messages: action.response,
        
        messageLimit: action.inLimit,
        messageOffset: action.inOffset,
        errorMessages: action.error,
    })
}

const storeMessageUnreadCount = (state, action) => {
    return state.merge({
        messageUnreadCount: action.response.messages
    })
}

const ACTION_HANDLERS = {
    [Types.STORE_MESSAGE_FROM]: storeMessageFrom,
    [Types.STORE_MESSAGES]: storeMessages,
    [Types.STORE_MESSAGE_UNREAD_COUNT]: storeMessageUnreadCount
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)


// WEBPACK FOOTER //
// ./src/Reducers/MessageReducer.js